import { useEffect, useState } from "react";
import { Modal } from "antd";
import useAxios from "../../../../MainComponents/Hooks/useAxios";

const EditCodeModal = ({ record, onFinishEdit }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [submitCodes, setSubmitCodes] = useState({
    flag: "",
    depedency: false,
    data: {},
  });

  const [formValues, setFormValues] = useState({
    code: "",
    price: "",
  });

  const [successEditCodes, errorEditCodes, loadingEditCodes] = useAxios(
    process.env.REACT_APP_EDIT_CODE_API,
    "POST",
    submitCodes.flag,
    submitCodes.depedency,
    submitCodes.data,
    true,
  );

  const onOpen = () => {
    setFormValues({
      code: record?.code ?? "",
      price: record?.price ?? "",
    });
    setIsModalOpen(true);
  };

  const onClose = () => {
    setIsModalOpen(false);
  };

  const handleSave = () => {
    setSubmitCodes({
      flag: "Edit codes",
      depedency: !submitCodes.depedency,
      data: {
        id: record.key,
        code: formValues.code,
        price: formValues.price,
      },
    });
  };

  useEffect(() => {
    if (successEditCodes) {
      onClose();
      onFinishEdit?.();
    }
  }, [successEditCodes, onFinishEdit]);

  return (
    <>
      <button
        onClick={onOpen}
        className="w-20 rounded-2xl border-2 border-accent bg-accent py-1 text-center font-semibold text-light duration-300 hover:bg-light hover:text-accent active:scale-90"
      >
        Edit
      </button>

      <Modal
        centered
        title="Edit Code"
        open={isModalOpen}
        onCancel={onClose}
        mask={false}
        maskClosable={false}
        footer={[
          <div key="footer" className="flex gap-10 justify-end">
            <button
              className="rounded-2xl border-2 border-red-600 bg-red-600 py-1 px-4 text-center font-semibold text-light duration-300 hover:bg-light hover:text-secondary active:scale-90"
              onClick={onClose}
              disabled={loadingEditCodes}
            >
              Cancel
            </button>

            <button
              className="px-4 rounded-2xl border-2 border-yellow-600 bg-yellow-600 py-1 text-center font-semibold text-light duration-300 hover:bg-light hover:text-secondary active:scale-90 text-nowrap"
              onClick={handleSave}
              disabled={loadingEditCodes}
            >
              {loadingEditCodes ? "Saving..." : "Save"}
            </button>
          </div>,
        ]}
      >
        <div className="flex flex-col gap-4">
          <div className="w-full">
            <label className="w-full truncate" htmlFor="code">
              Code
            </label>

            <input
              className="signin-inputs   w-full"
              name="code"
              id="code"
              type="text"
              value={formValues.code}
              onChange={(e) =>
                setFormValues((p) => ({ ...p, code: e.target.value }))
              }
              disabled={loadingEditCodes}
            />

            {errorEditCodes?.response?.data?.errors?.code && (
              <p className="w-full text-[12px] text-blue-900">
                {errorEditCodes.response.data.errors.code[0]}
              </p>
            )}
          </div>

          <div className="w-full">
            <label className="w-full truncate" htmlFor="price">
              Price
            </label>

            <input
              className="signin-inputs   w-full"
              name="price"
              id="price"
              type="text"
              value={formValues.price}
              onChange={(e) =>
                setFormValues((p) => ({ ...p, price: e.target.value }))
              }
              disabled={loadingEditCodes}
            />

            {errorEditCodes?.response?.data?.errors?.price && (
              <p className="w-full text-[12px] text-blue-900">
                {errorEditCodes.response.data.errors.price[0]}
              </p>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EditCodeModal;
